import axios from 'axios'
import { Toast } from 'vant'
// token=superqc&user=1&platform=1&shopId=11
axios.interceptors.request.use(config => {
  // config.headers['token'] = global.token
  // config.headers['platform'] = global.platform
  // config.headers['user'] = global.user
  // config.headers['shopId'] = global.shopId
  // config.headers['tableId'] = global.tableId

  config.headers['sdk'] = 'sjx'

  const token = sessionStorage.getItem('token')
  const phone = sessionStorage.getItem('phone')
  if(phone){
    config.headers['login-tel'] = phone
  }
  if(token){
    config.headers['Authorization'] = 'Bearer ' + token
    config.headers['User-Id'] = global.userId
    config.headers['User-Type'] = global.type
  }

return config
})
// 每次数据请求成功后返回的数据
axios.interceptors.response.use(
  response => {
    // if (response.data.code === 2) {
    //   Toast(response.data.msg)
    // }
    // return response


    if(response.data.code == "401"){
      console.log(response)
      Toast('登陆超时，请重新登录！')
      sessionStorage.clear()
      localStorage.clear()
      window.location.href = '#/login'
      return Promise.reject(response.data.msg)
    } else if(response.data.code == "403"){
      Toast('无操作权限！')
      sessionStorage.clear()
      localStorage.clear()
      window.location.href = '#/login'
      return Promise.reject(response.data.msg)
    }
    else
    {
      return response
    }
  },
  err => {
    return err
  }
)

export default axios



// WEBPACK FOOTER //
// ./src/axios.js